import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  FormLabel,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useEffect, useState } from "react";

const ModalComposerAliasName = ({ open, onClose, preload, onSubmit }) => {
  const [name, setName] = useState("");
  const handleSubmit = async () => {
    onSubmit(name, preload?.index);
    onClose();
  };
  useEffect(() => {
    if (preload) {
      setName(preload?.name);
    }
  }, [preload]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>{`${preload ? "Edit" : "Add"} Alias Name`}</DialogTitle>
      <DialogContent dividers>
        <FormLabel label="Alias Name" />
        <TextInput
          placeholder="Alias Name"
          value={name}
          onChange={e => setName(e?.target?.value)}
        />
      </DialogContent>
      <DialogActions>
        <SecondaryButton label="Cancel" onClick={onClose} />
        <PrimaryButton
          label={preload ? "Save" : "Add"}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalComposerAliasName;
